module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', [_c('div', {
    staticClass: "content-deactivation flexcenter"
  }, [_c('div', {
    staticClass: "content-deactivation-dialog flexcenter"
  }, [_c('div', {
    staticClass: "lbold font16"
  }, [_vm._v("使用を中止します"), _c('br'), _vm._v("（ストアページから再開できます）")]), _vm._v(" "), _c('div', {
    staticClass: "flexcenter buttons"
  }, [_c('button', {
    staticClass: "nobutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("いいえ")]), _vm._v(" "), _c('button', {
    staticClass: "yesbutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('deactivate', _vm.contentDetail);
        _vm.$emit('close');
      }
    }
  }, [_vm._v("はい")])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-88adeb48", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-88adeb48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchased/ContentDeactivation.vue
// module id = 727
// module chunks = 1